import React, { ComponentPropsWithRef } from 'react';

interface Props extends ComponentPropsWithRef<'div'> {}
export const Row = (p: Props) => {
  return <div className="row-auto">{p.children}</div>;
};
